import Storage from 'vue-ls'
import Vue from 'vue'

const localOptions = {
  namespace: 'pno__',
  name: 'localStorage',
  storage: 'local',
}

const sessionOptions = {
  namespace: 'pno__',
  name: 'sessionStorage',
  storage: 'session',
}

Vue.use(Storage, sessionOptions)
Vue.use(Object.assign({}, Storage), localOptions)
